import {
  Email,
  Facebook,
  GitHub,
  Instagram,
  LinkedIn,
  WhatsApp,
  YouTube,
} from "@material-ui/icons";
import Typical from "react-typical";
import "./profile.css";
import React, {useEffect, useState } from 'react';
import { HTTP } from "../../api/http-common";
import { HTMLDescription } from '../projects/HTMLDescription';


function Profile() {
  const [homeData, setHomeData] = useState(null);


  const socialMediaLinks = [
    {
      media_url: "https://www.linkedin.com/in/mohd-nafees-58172321b/",
      name: "LinkedIn"
    },
    {
      media_url: "https://github.com/uniquedeveloper143",
      name: "GitHub"
    },
    {
      media_url: "mailto:uniquedeveloper143@gmail.com",
      name: "Email"
    },
    {
      media_url: "https://www.facebook.com/mohd.nafees.56027",
      name: "Facebook"
    },
    // {
    //   media_url: "/",
    //   name:"<"YouTube
    // },
    {
      media_url: "https://wa.me/917490078839",
      name: "WhatsApp"
    },
    {
      media_url: "https://www.instagram.com/nafees786_92/",
      name: "Instagram"
    },

  ];
  
  const mediaIcons = {
    "Facebook": <Facebook />,
    "Instagram": <Instagram />,
    "LinkedIn": <LinkedIn />,
    "WhatsApp": <WhatsApp />,
    "YouTube": <YouTube />,
    "Email": <Email />,
    "GitHub": <GitHub />
  }

  const [mediaURLData, setMediaURLData] = useState(socialMediaLinks);

  useEffect(() => {

    let home_url = '/api/portfolio/home/'
    HTTP.get(home_url)
    .then(function (response) {
        // console.log(response.status);
        if(response.status === 200)
        {
          let data = response.data.results
          if (data.length > 0 )
          {
            setHomeData(response.data.results[0])
          }
          
        }
    })
    .catch(function (err) {
        console.log(err);
    });


    // this is call for media_url
    let media_url = '/api/portfolio/media-url/'
    HTTP.get(media_url)
    .then(function (response) {
        // console.log(response.status);

        if (response.status === 200 && response.data.results.length > 0) {
          setMediaURLData(response.data.results);
        } else {
          setMediaURLData(socialMediaLinks); // fallback if API returns empty
        }

    })
    .catch(function (err) {
        console.log(err);
    });


  }, []); // 👈 empty array ensures this runs once on component mount




  return (
    <div className="px-0">
      <div className="row mx-5">
        
        {/* this is for big screen */}
        <div className="col-6 big-screen profile-top">
          <div className="p-3 profile-container">
            <div className="profile-details-name mb-0">
              <div className="primary-text text-center">
                {" "}
                HEY THERE ! <span className="im"> I'M </span>
              </div>
            </div>

            <div className="profile-details-role">
              <span className="primary-text">
                {" "}
                <div className="profile-text">
                  {" "}
                  <Typical
                    loop={Infinity}
                    steps={[
                      homeData ? homeData.title : "Mohd Nafees",
                      3000,
                      "Software Engineer",
                      3000,
                      "Data Scientist",
                      3000,

                      // "Django Developer",
                      // 1000,
                      // "Django Rest Framework Developer",
                      // 1000,
                      // "React.js Developer",
                      // 1000,
                    ]}
                  />
                </div>
                
                <span className="profile-role-tagline">
                {
                  homeData 
                    ? 
                      <HTMLDescription description={homeData.description} />
                    : "Building purposeful digital experiences that blend logic, creativity, \
                    and intelligence—transforming ideas into impactful solutions through thoughtful \
                    design and smart development."
                }
                </span>
              </span>
            </div>
          
            
            <div className="link-icons mt-3 mb-2 text-center" style={{ height: "45px" }}>
              {
                mediaURLData.map((item, index) => (
                  
                  <a key={index} href={item.media_url} target="_blank" rel="noreferrer">
                    {mediaIcons[item.name]}
                  </a>

                ))
              }
            </div>


            <div className="profile-options text-center mt-3">
              {/* <button className="btn ">
                {""}
                Hire Me{" "}
              </button> */}
              <a href={homeData ? homeData.cv_url : "assets/Certificates_Images/Mohd_Nafees_resume.pdf"} 
              download="mohd_nafees_cv.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              >
                <button className="btn myResume"> Get Resume</button>
              </a>
            </div>
          </div>
        </div>

        <div className="col-6 big-screen ">
          <div className="p-1">
            <div className="profile-image">
              <div className="inner-profile-box">
                <div
                  className=""
                  //   style={{
                  //     backgroundImage: `url("assets/images/images.jpg 14")`,
                  //     backgroundRepeat: "no-repeat",
                  //     width: "90%",
                  //     // height: "600px",
                  //     backgroundSize: "cover",
                  //   }}
                >
                  <img src={homeData ? homeData.image : "assets/images/Mohd Nafees Image2.png"} alt="" className="rounded-circle z-depth-2 sideimage"/>
                  {/* <img
                    src="assets/images/images.jpg 12"
                    alt=""
                    className="rounded-circle z-depth-2 sideimage"
                  /> */}
                </div>
              </div>
            </div>
          </div>

          <div className="right-link-icons mt-3 text-center">

          {
              mediaURLData 
              ?
              <>

                {mediaURLData.map((item, index) => (
                  
                  <a key={index} href={item.media_url} target="_blank" rel="noreferrer">
                    {mediaIcons[item.name]}
                  </a>

                ))}

              </>
              :
              <>

              {socialMediaLinks.map((item, index) => (
                  <a key={index} href={item.href} target="_blank" rel="noreferrer">
                    {item.icon}
                  </a>
                ))}

              </>
          }
            {/* <a href="/">
              <Facebook />
            </a>
            <a href="/">
              <Instagram />
            </a>
            <a href="/">
              <LinkedIn />
            </a>
            <a href="/">
              <Twitter />
            </a>
            <a href="/">
              <YouTube />
            </a>
            <a href="/">
              <GitHub />
            </a> */}
          </div>

          {/* <div className="right-profile-options text-center mt-3">
            
            <a href={homeData ? homeData.cv_url : "assets/Certificates_Images/Mohd_Nafees_resume.pdf"} download="mohd_nafees_cv.pdf">
              <button className="btn myResume"> Get Resume</button>
            </a>
          </div> */}

        </div>

        {/* this is for small screen */}

        <div className="col-12 small-screen mt-4 ">
          <div className="p-1">
            <div className="profile-image">
              <div className="inner-profile-box">
                <div
                  className=""
                  //   style={{
                  //     backgroundImage: `url("assets/images/images.jpg 14")`,
                  //     backgroundRepeat: "no-repeat",
                  //     width: "90%",
                  //     // height: "600px",
                  //     backgroundSize: "cover",
                  //   }}
                >
                  <img src={homeData ? homeData.image : "assets/images/Mohd Nafees Image2.png"} alt="" className="rounded-circle z-depth-2 sideimage"/>
                  {/* <img
                    src="assets/images/images.jpg 12"
                    alt=""
                    className="rounded-circle z-depth-2 sideimage"
                  /> */}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="right-link-icons mt-3 text-center">

          {
              mediaURLData 
              ?
              <>

                {mediaURLData.map((item, index) => (
                  
                  <a key={index} href={item.media_url} target="_blank" rel="noreferrer">
                    {mediaIcons[item.name]}
                  </a>

                ))}

              </>
              :
              <>

              {socialMediaLinks.map((item, index) => (
                  <a key={index} href={item.href} target="_blank" rel="noreferrer">
                    {item.icon}
                  </a>
                ))}

              </>
          }
            
          </div> */}

          {/* <div className="right-profile-options text-center mt-3">
            
            <a href={homeData ? homeData.cv_url : "assets/Certificates_Images/Mohd_Nafees_resume.pdf"} download="mohd_nafees_cv.pdf">
              <button className="btn myResume"> Get Resume</button>
            </a>
          </div> */}

        </div>


        <div className="col-12 small-screen profile-top">
          <div className="p-3 profile-container">
            <div className="profile-details-name mb-0">
              <div className="primary-text text-center">
                {" "}
                HEY THERE ! <span className="im"> I'M </span>
              </div>
            </div>

            <div className="profile-details-role">
              <span className="primary-text">
                {" "}
                <div className="profile-text">
                  {" "}
                  <Typical
                    loop={Infinity}
                    steps={[
                      homeData ? homeData.title : "Mohd Nafees",
                      3000,
                      "Software Engineer",
                      3000,
                      "Data Scientist",
                      3000,

                      // "Django Developer",
                      // 1000,
                      // "Django Rest Framework Developer",
                      // 1000,
                      // "React.js Developer",
                      // 1000,
                    ]}
                  />
                </div>
                
                <span className="profile-role-tagline">
                {
                  homeData 
                    ? 
                      <HTMLDescription description={homeData.description} />
                    : "Building purposeful digital experiences that blend logic, creativity, \
                    and intelligence—transforming ideas into impactful solutions through thoughtful \
                    design and smart development."
                }
                </span>
              </span>
            </div>
          
            
            <div className="link-icons m-2 text-center" style={{ height: "45px" }}>
              {
                mediaURLData.map((item, index) => (
                  
                  <a key={index} href={item.media_url} target="_blank" rel="noreferrer">
                    {mediaIcons[item.name]}
                  </a>

                ))
              }
            </div>


            <div className="profile-options text-center ">
              {/* <button className="btn ">
                {""}
                Hire Me{" "}
              </button> */}
              <a href={homeData ? homeData.cv_url : "assets/Certificates_Images/Mohd_Nafees_resume.pdf"} 
              download="mohd_nafees_cv.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              >
                <button className="btn myResume"> Get Resume</button>
              </a>
            </div>
          </div>
        </div>



      </div>
    </div>
  );
}

export default Profile;
